import { CircularProgress, Dialog, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';

const styles = theme => ({
  root: {
    padding: '1rem 2rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  message: {
    fontWeight: 'bold',
    paddingRight: theme.spacing(1),
  },
  circular: {
    margin: theme.spacing(1),
    opacity: 1.4,
    color: 'primary',
  },

});

class Loading extends React.Component {
  render () {
    const { loading, message, classes } = this.props;

    return (
      <Dialog open={loading}>
        <Typography component={'span'} className={classes.root}>
          <CircularProgress className={classes.circular} />
          <Typography component={'span'} className={classes.message}>{message}</Typography>
        </Typography>
      </Dialog>
    );
  }
}

export default withStyles(styles)(Loading);
